<template>
  <validate validations='required' :validated-value="signature" v-on="$listeners">
    <signature
      height="145px"
      @signed="setSignature"/>
  </validate>
</template>

<script>
import Validate from '@/components/helpers/Validate';
import BaseUI from 'base-ui';

export default {
  name: 'SignatureWithValidation',
  components: {
    Signature: BaseUI.Signature,
    Validate,
  },
  data() {
    return {
      signature: undefined,
    };
  },
  methods: {
    setSignature(data) {
      this.signature = data;
      this.$emit('signed', data);
    },
  },
};
</script>
